import { Container } from '@almbrand/container';
import { Headline } from '@almbrand/headline';
import React from 'react';
import { replacePlaceholdersSummaryComponent } from '../../../services/PlaceholderService';
import styles from './SummaryTotalPriceComponent.module.scss';

export const SummaryTotalPriceComponent: React.FC<SummaryTotalPriceDetailsBlock> = ({
	priceAmountHeader,
	totalPriceLabel,
}) => {
	const label = totalPriceLabel.split(/({{.*?}})/).map((str) => str.trim());

	const replacedPlaceholder: SummaryTotalPriceDetailsBlock = {
		totalPriceLabel: label[1],
	};

	replacePlaceholdersSummaryComponent(replacedPlaceholder);

	return (
		<section>
			<Container
				noPadding
				mobileWidth='fullWidth'
			>
				<div className={styles.SummaryTotalPriceComponent}>
					<div className={styles.SummaryTotalPriceComponent__currency}>{priceAmountHeader}</div>
					<div className={styles.SummaryTotalPriceComponent__pricing}>
						<div className={styles.SummaryTotalPriceComponent__pricing__label}>
							<Headline
								variant='h2'
								fontColor='primaryDark'
								title={label[0]}
								size='xs'
							/>
						</div>
						<div className={styles.SummaryTotalPriceComponent__pricing__value}>
							<Headline
								variant='h2'
								fontColor='primaryDark'
								title={`${label[1]},-`}
								size='xs'
							/>
						</div>
					</div>
				</div>
			</Container>
		</section>
	);
};
